webpackJsonp([0],{

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1245)
__webpack_require__(1246)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(1242),
  /* template */
  __webpack_require__(1247),
  /* scopeId */
  "data-v-28a249d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_user__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_login__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_dict__ = __webpack_require__(102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      dictOrgType: [],
      account: {
        username: "",
        pwd: "",
        type: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur"
          //{ validator: validaePass }
        }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur"
          //{ validator: validaePass2 }
        }],
        type: [{ required: true, message: '请选择机构类型', trigger: 'blur' }]
      },
      checked: true
    };
  },

  mounted: function mounted() {
    //页面初始化方法
    var params = "";
    var that = this;
    __WEBPACK_IMPORTED_MODULE_3__api_api_dict__["a" /* default */].dictOrgType(params).then(function (result) {
      if (result && result.code == 200) {
        that.dictOrgType = result.data;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: {
    handleReg: function handleReg() {
      this.$router.push({ path: "/reg" });
    },
    handleLogin: function handleLogin() {
      var _this = this;

      var that = this;
      this.$refs.AccountFrom.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          var loginParams = new FormData();
          //loginParams.append('client_id', 'app');
          //loginParams.append('client_secret', '123456');
          //loginParams.append('grant_type', 'password');
          loginParams.append('type', _this.account.type);
          loginParams.append('username', _this.account.username);
          loginParams.append('password', _this.account.pwd);
          __WEBPACK_IMPORTED_MODULE_1__api_api_user__["a" /* default */].login(loginParams).then(function (result) {
            // console.log(result)
            that.loading = false;
            if (result && result.code == 200) {
              var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
              //console.log(result.data.organization.id);
              window.localStorage.setItem("access-user", data);
              if (result.data.organization == undefined) {
                that.$router.push({ path: "/" });
              } else {
                if (result.data.adminAccount || result.data.organization.agree) {
                  that.$router.push({ path: "/" });
                } else {
                  that.$router.push({ path: "/agree" });
                }
              }
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg || "登录失败",
                duration: 2000
              });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)();
// imports


// module
exports.push([module.i, "body{margin:0;padding:0;width:100%;height:100%;background-size:cover;background-position:top;font:14px/1.5 tahoma,arial,Hiragino Sans GB,\\\\5B8B\\4F53,sans-serif;-webkit-font-smoothing:antialiased;font-weight:300}", "", {"version":3,"sources":["D:/workspace/yuping/ypxf/yuping-view/src/components/Login.vue"],"names":[],"mappings":"AACA,KACE,SAAS,AACT,UAAU,AACV,WAAW,AACX,YAAY,AAEX,sBAAuB,AACxB,wBAAwB,AACxB,mEAAuE,AACvE,mCAAoC,AACpC,eAAiB,CAClB","file":"Login.vue","sourcesContent":["\nbody {\n  margin:0;\n  padding:0;\n  width:100%;\n  height:100%;\n  /* background:url(\"../assets/images/loginbg.png\"); */\n   background-size: cover;\n  background-position:top;\n  font: 14px/1.5 tahoma,arial,'Hiragino Sans GB','\\5b8b\\4f53',sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)();
// imports


// module
exports.push([module.i, ".login-container[data-v-28a249d8]{-webkit-border-radius:5px;border-radius:5px;-moz-border-radius:5px;background-clip:padding-box;margin:160px auto;width:450px;padding:35px 35px 15px;background:#fff;border:1px solid #eaeaea;box-shadow:0 0 25px #cac6c6;background:-ms-linear-gradient(top,#ace,#00c1de);background:-moz-linear-gradient(top,#ace,#00c1de);background:-webkit-gradient(linear,0 0,0 100%,from(#ace),to(#00c1de));background:-webkit-linear-gradient(top,#ace,#00c1de);background:-o-linear-gradient(top,#ace,#00c1de)}.login-container .title[data-v-28a249d8]{margin:0 auto 40px;text-align:center;color:#505458}.login-container .remember[data-v-28a249d8]{margin:0 0 35px}", "", {"version":3,"sources":["D:/workspace/yuping/ypxf/yuping-view/src/components/Login.vue"],"names":[],"mappings":"AAEA,kCAEE,0BAA2B,AAC3B,kBAAmB,AACnB,uBAAwB,AACxB,4BAA6B,AAC7B,kBAAmB,AACnB,YAAa,AACb,uBAA6B,AAC7B,gBAAiB,AACjB,yBAA0B,AAC1B,4BAA6B,AAC7B,iDAAoD,AAEpD,kDAAqD,AAErD,sEAA8E,AAE9E,qDAAwD,AAExD,+CAAmD,CAEpD,AACD,yCACI,mBAA2B,AAC3B,kBAAmB,AACnB,aAAe,CAClB,AACD,4CACI,eAAyB,CAC5B","file":"Login.vue","sourcesContent":["\n@charset \"UTF-8\";\n.login-container[data-v-28a249d8] {\n  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n  -moz-border-radius: 5px;\n  background-clip: padding-box;\n  margin: 160px auto;\n  width: 450px;\n  padding: 35px 35px 15px 35px;\n  background: #fff;\n  border: 1px solid #eaeaea;\n  box-shadow: 0 0 25px #cac6c6;\n  background: -ms-linear-gradient(top, #ace, #00c1de);\n  /* IE 10 */\n  background: -moz-linear-gradient(top, #ace, #00c1de);\n  /*火狐*/\n  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#ace), to(#00c1de));\n  /*谷歌*/\n  background: -webkit-linear-gradient(top, #ace, #00c1de);\n  /*Safari5.1 Chrome 10+*/\n  background: -o-linear-gradient(top, #ace, #00c1de);\n  /*Opera 11.10+*/\n}\n.login-container .title[data-v-28a249d8] {\n    margin: 0px auto 40px auto;\n    text-align: center;\n    color: #505458;\n}\n.login-container .remember[data-v-28a249d8] {\n    margin: 0px 0px 35px 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1240)("09746908", content, true);

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1244);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1240)("ee72309a", content, true);

/***/ }),

/***/ 1247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "AccountFrom",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.account,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.account.username),
      callback: function($$v) {
        _vm.$set(_vm.account, "username", $$v)
      },
      expression: "account.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.account.pwd),
      callback: function($$v) {
        _vm.$set(_vm.account, "pwd", $$v)
      },
      expression: "account.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "机构类型"
    },
    model: {
      value: (_vm.account.type),
      callback: function($$v) {
        _vm.$set(_vm.account, "type", $$v)
      },
      expression: "account.type"
    }
  }, _vm._l((_vm.dictOrgType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin($event)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleReg($event)
      }
    }
  }, [_vm._v("注册 ")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.5ac7651adbdf01df6462.js